const API_ANNOUNCE_MODE = true

function emptyMsg(method: string) {
  if (method === 'GET' || method === 'DELETE') {
    return 'no querystring'
  }
  return 'no body'
}

export function announceSend(method: string, url: string, data?: unknown) {
  if (!API_ANNOUNCE_MODE) {
    return
  }
  if (data !== undefined) {
    console.log(`Sending:   ${method} ${url} => ${JSON.stringify(data)}`)
  } else {
    console.log(`Sending:   ${method} ${url}    (${emptyMsg(method)})`)
  }
}
export function announceReturn(method: string, url: string, data?: unknown) {
  if (!API_ANNOUNCE_MODE) {
    return
  }
  if (data !== undefined) {
    console.log(`Returned:  ${method} ${url} => ${JSON.stringify(data)}`)
  } else {
    console.log(`Returned:  ${method} ${url}    (${emptyMsg(method)})`)
  }
}
